import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import LinkTableCellComponent from "../common/LinkTableCellComponent";
import Label1 from "../common/Label1";
import {Icon, IconButton} from "@material-ui/core";


const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ContractInfo = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: repeat(3, max-content);
    grid-column-gap: 32px;
    
    > div {
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-row-gap: 10px;    
    }
`;

const ContractHeading = styled.div`
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 10px;    
`;

function PaymentLineItem({contractId, status,nextPayment, paymentDue, totalBalance, onContractIdClick, onMoreBtnClick}) {
    return (
        <PageWrapper>
            <ContractHeading>
                <div>Contract ID: <LinkTableCellComponent name={contractId} onLinkClick={onContractIdClick}/> </div>
                <div>{status}</div>
            </ContractHeading>

            <ContractInfo>
                <div>
                    <Label1>
                        NextPayment
                    </Label1>

                    <div>
                        {nextPayment}
                    </div>
                </div>

                <div>
                    <Label1>
                        Payment Due
                    </Label1>

                    <div>
                        {paymentDue}
                    </div>
                </div>

                <div>
                    <Label1>
                        Total Balance
                    </Label1>

                    <div>
                        {totalBalance}
                    </div>
                </div>
            </ContractInfo>

            <div>
                <IconButton onClick={onMoreBtnClick}>
                    <Icon fontSize="large">more_vert</Icon>
                </IconButton>
            </div>
        </PageWrapper>
    );
}

PaymentLineItem.propTypes = {};
PaymentLineItem.defaultProps = {};

export default PaymentLineItem;
